<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">


        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">图标</div>
            <el-upload
                action=""
                :limit="1"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-progress="onProgress"
                :on-success="imgSuccess"
                :on-error="imgError"
                :http-request="uploadHttp"
                list-type="picture-card"
                :on-remove="handleRemove"
                :class="{disabled:uploadDisabled}"
                :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
              <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
            </el-dialog>

          </el-col>
          <el-col :span="12" class="item">
            <div class="label">活动分类</div>
            <el-select v-model="activityClassCode" filterable clearable placeholder="请选择活动分类" style="width: 100%">
              <el-option
                  v-for="item in activityClassList"
                  :key="item.activityClassCode"
                  :label="item.name"
                  :value="item.activityClassCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

<!--        <el-row class="row">-->
<!--          <el-col :span="12" class="item">-->
<!--            <div class="label">活动分类</div>-->
<!--            <el-select v-model="activityTypeCode" @change="typeChange" filterable clearable placeholder="请选择活动分类" style="width: 100%">-->
<!--              <el-option-->
<!--                  v-for="item in activityTypeList"-->
<!--                  :key="item.activityTypeCode"-->
<!--                  :label="item.name"-->
<!--                  :value="item.activityTypeCode">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
<!--          <el-col :span="12" class="item">-->
<!--            <div class="label">活动项目</div>-->
<!--            <el-select v-model="activityItemCode" clearable placeholder="请选择活动项目" style="width: 100%">-->
<!--              <el-option-->
<!--                  v-for="item in activityItemList"-->
<!--                  :key="item.activityItemCode"-->
<!--                  :label="item.name"-->
<!--                  :value="item.activityItemCode">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
<!--        </el-row>-->



        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动内容</div>
            <el-input v-model="edit_Name" placeholder="请输入活动内容" ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">频次</div>
            <el-input v-model="edit_frequency" placeholder="请输入频次" ></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">状态</div>
            <el-select v-model="edit_status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
              <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍</div>
            <el-select v-model="volunteerTeamCode" filterable clearable placeholder="请选择志愿队伍" style="width: 100%">
              <el-option
                  v-for="item in volunteerTeamList"
                  :key="item.volunteerTeamCode"
                  :label="item.name"
                  :value="item.volunteerTeamCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',

      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],
      edit_status: -1,

      edit_frequency:'',
      edit_imgPath:'',


      activityTypeList:[],
      activityTypeCode:'',

      activityItemList:[],
      activityItemCode:'',


      activityClassList:[],
      activityClassCode:'',

      volunteerTeamList:[],
      volunteerTeamCode:'',

      activityContentCode :'',


      //上传身份证正面相关参数
      limitCount: 1,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

    }
  },
  methods: {

    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
      this.uploadDisabled = false;
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = true;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
      this.uploadDisabled = true;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.uploadDisabled = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file,fileList);
      this.uploadDisabled = false;
    },
    //图片更改
    handleChange(fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
      this.uploadDisabled = true;
    },

    uploadHttp(file) {

      //获取文件信息
      //let fileLen = file.file;
      //let name = fileLen.name

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.edit_imgPath = that.$imgUrl+res.data.data.path;
      })


    },

    init(row){

      if(row.imgPath != '' && row.imgPath !=null){


        let obj = new Object();
        obj.url = this.$imgUrl+row.imgPath;

        this.edit_imgPath = this.$imgUrl+row.imgPath;

        this.fileList = [];
        this.fileList.push(obj);
        this.uploadDisabled= true;
      }else{
        this.fileList = [];
        this.uploadDisabled = false;
        this.edit_imgPath = "";
      }


      this.edit_Name = row.name;
      this.edit_frequency = row.frequency;
      this.edit_status = row.status;

      //this.activityTypeCode = row.activityTypeCode;
      //this.activityItemCode = row.activityItemCode;

      this.activityClassCode = row.activityClassCode;
      this.volunteerTeamCode = row.volunteerTeamCode;

      this.activityContentCode = row.activityContentCode;

      //this.getTypeList();
      this.getVolunteerTeamList();

      this.getClassList();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      // if(this.activityTypeCode === ''){
      //   this.$message("请选择活动分类");
      //   return;
      // }
      // if(this.activityItemCode === ''){
      //   this.$message("请选择活动项目");
      //   return;
      // }

      if(this.activityClassCode === ''){
        this.$message("请选择活动分类");
        return;
      }

      if(this.edit_Name === ''){
        this.$message("输入活动内容");
        return;
      }
      if(this.edit_frequency === ''){
        this.$message("输入频次");
        return;
      }
      if(this.edit_status === -1){
        this.$message("选择状态");
        return;
      }



      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityContent/Edit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          frequency:this.edit_frequency,
          status:this.edit_status,
          //activityTypeCode:this.activityTypeCode,
          //activityItemCode:this.activityItemCode,
          activityClassCode:this.activityClassCode,
          activityContentCode:this.activityContentCode,
          imgPath:this.edit_imgPath.replace(this.$imgUrl,""),
          volunteerTeamCode:this.volunteerTeamCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    changeStatus:function (selVal) {
      this.edit_status = selVal;
    },



    typeChange(val){
      this.activityTypeCode = val;
      this.activityItemCode = '';
      this.getItemList();
    },

    getTypeList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityType/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityTypeList = response.data.data.list;

          for(let i=0;i<this.activityTypeList.length;i++){
            if(this.activityTypeList[i].activityTypeCode == this.activityTypeCode){
              this.getItemList();
            }
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getItemList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityItem/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityTypeCode:this.activityTypeCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityItemList = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



    getVolunteerTeamList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.volunteerTeamList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityClass/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityClassList = response.data.data.list;

          if(this.activityClassList.length>0){
            this.activityClassCode = this.activityClassList[0].activityClassCode;
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>